'use client';

import { memo } from 'react';

import { useTranslations } from 'next-intl';
import { UseFormReturn } from 'react-hook-form';

import ProfileInformationInput from '@/app/[locale]/(main)/profile/edit/_components/ProfileInformation/ProfileInformationInput';
import ProfileInformationSelect from '@/app/[locale]/(main)/profile/edit/_components/ProfileInformation/ProfileInformationSelect';
import FormMessage from '@/components/shared/FormMessage';
import { Form, FormField, FormItem, FormControl } from '@/components/ui/form';
import { T_ProfileFormData } from '@/schemas/profileForm.schema';
import { C_LanguageOptions } from '@/ts/constants/C_LanguageOptions';
import { E_ProfileForm } from '@/ts/enums/E_ProfileForm';
import { T_Country } from '@/ts/types/T_Country';

interface I_ProfileFormProps {
  form: UseFormReturn<T_ProfileFormData>;
  countries: T_Country[];
}

const ProfileForm = memo(function ProfileForm({
  form,
  countries
}: I_ProfileFormProps) {
  const t = useTranslations('editProfile');

  return (
    <Form {...form}>
      <div className="grid gap-4 w-full">
        <FormField
          control={form.control}
          name={E_ProfileForm.NICKNAME}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <ProfileInformationInput field={field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name={E_ProfileForm.LANGUAGE}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <ProfileInformationSelect
                  type="language"
                  field={field}
                  options={C_LanguageOptions}
                  placeholder={t('form.language')}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name={E_ProfileForm.COUNTRY}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <ProfileInformationSelect
                  type="country"
                  field={field}
                  options={countries}
                  placeholder={t('form.timezone')}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        {/* Todo */}
        {/* <FormField
          control={form.control}
          name={E_ProfileForm.HIDE_ACTIVITY}
          render={({ field }) => (
            <FormItem className="flex items-center gap-3">
              <FormControl>
                <Checkbox
                  id="hideActivity"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                  className="cursor-pointer"
                />
              </FormControl>
              <FormLabel
                htmlFor="hideActivity"
                className="w-full cursor-pointer"
              >
                {t('form.hideActivity')}
              </FormLabel>
              <FormMessage />
            </FormItem>
          )}
        /> */}
      </div>
    </Form>
  );
});

export default ProfileForm;
